// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uEmujTzmkooRY7596p9z{padding:3px 22px 3px 3px;position:relative}.uEmujTzmkooRY7596p9z .Z0ZfabvjYAITwsMDlaHH{margin:22px 0 18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uEmujTzmkooRY7596p9z`,
	"tabs": `Z0ZfabvjYAITwsMDlaHH`
};
export default ___CSS_LOADER_EXPORT___;
